import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    border: 0;
    box-sizing: inherit;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    outline: 0;
    padding: 0;
    text-decoration: none;
    text-rendering: optimizeLegibility;
  }

  html {
    box-sizing: border-box;
    height: 100%;
    margin: 0;
    padding: 0;

    /* For iOS scrolling */
    overflow: hidden;
  }

  table {
    border-spacing: 0;
  }

  textarea {
    resize: none;
  }

  button {
    font-family: inherit;
    font-size: 1em;
  }

  /* Safari 13 bug causes browser to crash */
  /* https://bugs.webkit.org/show_bug.cgi?id=202055 */
  select {
    text-rendering: auto !important
  }
`;
